<i-title styleClass="w-100" [text]="('modals.previewModel' | translate) + ' ' + template?.description"
  [buttons]="titleButtons" level="1"></i-title>

<div class="modal-body modal-scss">
  <div class="myEditorForModal">
    <i-richedit [lang]="lang" [options]="{ readOnly: true }" [showMergeFields]="true" [mergeFields]="mergeFields()"
      #document_editor></i-richedit>
    <div class="mb-4"></div>
  </div>
</div>